import React from "react";

type Props = {
  children?: React.ReactNode;
  onRemove?: () => void;
};

const Chip: React.FC<Props> = ({ children, onRemove }) => (
  <div className="inline-flex items-center bg-purple-100 text-purple-600 px-2.5 py-1.5 rounded-md mr-2 mb-2">
    <span className="mr-2">{children}</span>
    {onRemove ? (
      <button 
        onClick={onRemove} 
        className="border-none bg-transparent cursor-pointer text-purple-600 hover:text-purple-700 transition"
      >
        ×
      </button>
    ) : null}
  </div>
);

export default Chip;
